/**
 * The brand mark — five vertical ink stripes (C M Y K · Orange) next to the
 * wordmark. The only place the full palette appears together. Stripe order
 * is locked in the design brief; do not reorder.
 */
const STRIPES = ['#00B4D8', '#E63B7A', '#F4C430', '#F5EEDC', '#FF8A4C'];

export const BrandStripe = ({ height = 20, width = 5 }) => (
  <div class="flex" aria-hidden="true">
    {STRIPES.map((color) => (
      <span
        key={color}
        style={{ background: color, width: `${width}px`, height: `${height}px` }}
      />
    ))}
  </div>
);
